// Libs
import React from 'react'

// CSS
import './styles.scss'

const Shout = ({ children }) => (
  <div className="shout">
    {children}
  </div>
)

export default Shout
